import ApplicationBrand from 'components/common/ApplicationBrand'
import Img from 'components/common/Img'
import { Button, Conditional, Text } from 'iq-blueberry'
import { SecurityWarning } from 'pages/credit/BbOurocard/components/SecurityWarning'
import './style.styl'
import FormFooter from 'components/Layouts/StepFormLayout/FormFooter'
import { partnerConfig } from 'pages/credit/BbOurocard/configs'
import Loader from 'components/common/Loader'

export function PictureConfirmation({
  imagePath,
  title,
  description,
  handleContinue,
  handleTakeOtherPhoto,
}) {
  return (
    <div className="picture-review">
      <div className="picture-review__header">
        <ApplicationBrand isSmall />
      </div>
      <div className="picture-review__body">
        <Conditional
          condition={imagePath}
          renderIf={
            <img
              className="picture-review__image"
              src={imagePath}
              alt="Sua selfie"
            />
          }
          renderElse={
            <div className="picture-review__loader">
              <Loader />
            </div>
          }
        />
        <div>
          <div className="picture-review__text-container">
            <Text
              className="picture-review__text-container__title"
              as="h4"
              variant="heading-five">
              {title}
            </Text>
            <Text
              className="picture-review__text-container__desc"
              as="p"
              variant="body-medium">
              {description}
            </Text>
          </div>
          <div className="picture-review__button-container">
            <Button expand="x" justify="center" onClick={handleContinue}>
              Está boa, quero continuar
            </Button>
            <Button
              type="secondary"
              expand="x"
              justify="center"
              onClick={handleTakeOtherPhoto}>
              <Img
                className="picture-review__button-container--icon-button"
                src={`images/camera-icon.svg`}
              />
              Quero tirar outra foto
            </Button>
            <div className="picture-review__button-container__warning">
              <SecurityWarning text="Todos os dados enviados são confidenciais" />
            </div>
          </div>
        </div>
      </div>
      <div className='picture-review__footer'>
        <FormFooter partnerLogo={partnerConfig.partnerLogo} />
      </div>
    </div>
  )
}
